import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Shield } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/context/LanguageContext';
import HeroSearchBox from './HeroSearchBox';

const HeroSection = () => {
  const navigate = useNavigate();
  const { t, getLocalizedPath } = useLanguage();

  const handleTherapistSignup = () => {
    navigate(getLocalizedPath('/for-therapists'));
  };

  return (
    <section className="relative min-h-screen flex items-start py-0 md:py-4">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-hero -z-10" />
      
      <div className="container relative z-10">
        <div className="max-w-5xl mx-auto text-center hero-content">
          
          {/* Hero Search Box - CONVERSION FIRST */}
          <HeroSearchBox className="mb-6 mt-2" />
          
          {/* Trust Badge */}
          <Badge className="mb-4 px-4 py-2 text-sm bg-primary/10 text-primary border-primary/20 hover:bg-primary/20">
            ⭐ Rated 4.8/5 by 50,000+ clients worldwide
          </Badge>
          
          {/* Main Headline */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-4 leading-tight">
            Find Your Perfect{' '}
            <span className="gradient-text">
              Therapist
            </span>
            {' '}in Minutes
          </h1>
          
          {/* Subtitle */}
          <p className="text-lg md:text-xl lg:text-2xl text-muted-foreground mb-8 max-w-3xl mx-auto">
            Connect with certified mental health professionals worldwide.
            <br className="hidden md:block" />
            Online or in-person. Your language. Sessions from $25.
          </p>
          
          {/* Trust Indicators - Inline */}
          <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm">
            <div className="flex items-center gap-2">
              <span className="text-green-500 text-xl">●</span>
              <span>237 therapists available now</span>
            </div>
            <div className="flex items-center gap-2">
              <CheckCircle className="h-4 w-4 text-blue-500" />
              <span>5,000+ verified professionals</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-purple-500" />
              <span>100% confidential & secure</span>
            </div>
          </div>
          
          {/* Secondary CTA for Therapists */}
          <p className="mt-8 text-sm text-muted-foreground">
            Are you a therapist?{' '}
            <Button 
              variant="link" 
              className="p-0 h-auto font-medium"
              onClick={handleTherapistSignup}
            >
              Join our network →
            </Button>
          </p>
          
        </div>
      </div>
      
      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background to-transparent pointer-events-none" />
    </section>
  );
};

export default HeroSection;
